import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import oHomeLangResources from '../app/homeApp/config/langResources.js';
import { AgreementPdfResources } from '../app/agreementPdfApp/config/langResources.js';
import { OpenedAgreementResources } from '../app/openedAgreementApp/config/langResources.js';
import { SurveyResources } from '../app/surveyApp/config/langResources.js';
import { clientConfirmationResources } from '../app/clientConfirmationApp/config/langResources.js';
import { SearchResources } from '../app/searchApp/config/langResources.js';
import { RequestSignatureResources } from '../app/requestSignatureApp/config/langResources.js';
import { PaymentResources } from '../app/paymentApp/config/langResources.js';
import { QuotationResources } from '../app/quotationApp/config/langResources.js';
import { ComponentResources } from '../components/config/langResources.js';
import { AdditionalDriverResources } from '../app/quotationApp/AdditionalDriverApp/config/langResources.js';
import { DefaultMenuResources } from '../app/defaultMenu/config/langResources.js';

const sLang = document.querySelector('html').lang;

i18n
  .use(initReactI18next)
  .init({
    lng: sLang,
    debug: false,
    fallbackLng: 'es',
    interpolation: {
      	escapeValue: false,
    },
    resources: {
      	es: {
	        translation: {
	          	App: {
	              	['general_error_403']: 'No tiene permisos para realizar esta acción',
	              	['on_the_device']: 'En el dispositivo pinpad',
	              	['return']: 'Regresar',
                    ['next']: 'Siguiente',
                    ['confirm']: 'Confirmar',
                    ['save']: 'Guardar',
                    ['close']: 'Cerrar',
                    ['add']: 'Agregar',
                    ['finish']: 'Terminar',
                    ['select_value']: 'Selecciona un valor',
                    ['or']: 'o',
                    ['Components']: { ...ComponentResources['es'] }
		        },
	          	Error: {
		            ['uncontrolled_error']: 'Error no controlado',
		            ['unexpected_error_occurred']: 'Ocurrió un fallo inesperado, por favor intenta de nuevo más tarde.',
		            ['fields_all_required']: 'Completa los campos requeridos',
		            ['this_field_is_required']: 'Este campo es obligatorio',
		            ['incorrect_rfc_format']: 'RFC con formato erróneo',
		            ['invalid_email']: 'Correo no válido',
	          	},
		        Success: {
		            ['successfully']: 'exitosamente',
                    ['email_sent']: 'Contrato enviado al corrreo con exito'
	          	},
	          	Alert: {
		            ['admin']: 'Administración',
		        },
		        Home: {...oHomeLangResources['es']},
                AgreementPdf: {...AgreementPdfResources['es']},
                OpenedAgreement: {...OpenedAgreementResources['es']},
                Survey: {...SurveyResources['es']},
                ClientConfirmation: {...clientConfirmationResources['es']},
                Search: {...SearchResources['es']},
                RequestSignature: {...RequestSignatureResources['es']},
                Payment: {...PaymentResources['es']},
                Quotation: {...QuotationResources['es']},
                AdditionalDriver: { ...AdditionalDriverResources['es'] },
                DefaultMenu: { ...DefaultMenuResources['es'] },
	        }
	    },
      	en: {
        	translation: {
          		App: {
              		['general_error_403']: 'You do not have permissions to perform this action',
	              	['on_the_device']: 'On the pinpad device',
	              	['return']: 'Return',
                    ['next']: 'Next',
                    ['confirm']: 'Confirm',
                    ['save']: 'Save',
                    ['close']: 'Close',
                    ['add']: 'Add',
                    ['finish']: 'Finish',
                    ['select_value']: 'Select a value',
                    ['or']: 'or',
                    ['Components']: { ...ComponentResources['en'] }
	        	},
          		Error: {
            		['uncontrolled_error']: 'Uncontrolled error',
            		['unexpected_error_occurred']: 'An unexpected error occurred, please try again later.',
            		['fields_all_required']: 'Fill all required fields',
		            ['this_field_is_required']: 'This field is required',
		            ["incorrect_rfc_format"]: "Incorrect RFC format",
		            ['invalid_email']: 'Invalid Email',
		        },
		        Success: {
		            ['successfully']: 'successfully',
                    ['email_sent']: 'Agreement sent to email successfully'
		        },
		       	Alert: {
		            ['admin']: 'Administration',
		            ['required_select_unit']: 'You are required to select a unit or mark the contract as unitless in order to continue.',
		        },
		        Home: {...oHomeLangResources['en']},
                AgreementPdf: {...AgreementPdfResources['en']},
                OpenedAgreement: {...OpenedAgreementResources['en']},
                Survey: {...SurveyResources['en']},
                ClientConfirmation: {...clientConfirmationResources['en']},
                Search: {...SearchResources['en']},
                RequestSignature: {...RequestSignatureResources['en']},
                Payment: {...PaymentResources['en']},
                Quotation: {...QuotationResources['en']},
                AdditionalDriver: { ...AdditionalDriverResources['en'] },
                DefaultMenu: { ...DefaultMenuResources['en'] },
	        }
	    }
    }
});

export default i18n;
